export const translations = {
  ARIA_LABEL_NAMESPACE: 'ariaLabels',
  SLIDE_SHOW_ARIA_LABEL_KEY: 'SlideShow_AriaLabel_TopLevel',
  SLIDE_SHOW_ARIA_LABEL_DEFAULT: 'Slideshow',
  NEXT_BTN_ARIA_LABEL_KEY: 'SlideShow_AriaLabel_Button_Next',
  NEXT_BTN_ARIA_LABEL_DEFAULT: 'Next',
  PREV_BTN_ARIA_LABEL_KEY: 'SlideShow_AriaLabel_Button_Previous',
  PREV_BTN_ARIA_LABEL_DEFAULT: 'Previous',
  NAVIGATION_DOTS_ARIA_LABEL_KEY: 'SlideShow_AriaLabel_NavigationDots',
  NAVIGATION_DOTS_ARIA_LABEL_DEFAULT: 'Slides',
  PLAY_CONTROL_ARIA_LABEL_KEY: 'PlayControl_AriaLabel',
  PAUSE_CONTROL_ARIA_LABEL_KEY: 'PauseControl_AriaLabel',
};

export const TestIds = {
  slidesWrapper: 'slidesWrapper',
  nextButton: 'nextButton',
  prevButton: 'prevButton',
  dotsNavigationButtons: 'dotsNavigationButtons',
  shadowLayer: 'shadowLayer',
  pauseResumeButton: 'pauseResumeButton',
} as const;

export const NO_TRANSITION = 'NoTransition';
